<template>
<div class="featureitem">
    <router-link :to="{path:'/booklist',query:{listId:books.listId}}">
        <div class="itemcard">
            <img class="faceimg" :src="books.faceImg | objs" />
            <p class="f18">
                 <nobr> {{books.name}}</nobr>
            </p>  
            <p class="f14" v-html="books.intro"> </p>
            <p class="f12">
				<!-- <span class="ludubi">{{books.buyPrice || '0.00'}}</span> -->
				<span class="last" v-if="books.isLast==2">完结</span><span class="floatright">（已更新至{{books.sumCount}}期）</span></p>
             
        </div>
    </router-link>
</div>
</template>

<style scoped>
a{text-decoration: none;}
p{padding: 0px 20px;}
.featureitem {
    width: 33.3333%;
    height:350px;
    overflow: hidden;
    float: left;
    margin-top: 30px;
}

.itemcard {
    width: 94%;
    margin:0 auto;
    padding-bottom: 10px;
    box-shadow: 0px 0px 20px 2px rgba(173, 195, 190, 0.29);
    border-radius: 2px; 
}
.itemcard:hover{
     box-shadow: 0px 0px 20px 2px rgba(185, 255, 239, 0.6);
}
.faceimg {
    width: 100%;
}
.f18{ 
font-size: 18px; 
overflow: hidden; 
font-weight: bold;
color: #242A27;
font-family: Source Han Serif CN;
font-weight: 500;
margin: 20px 0 0 0;
}
.f14{ 
font-size: 14px;
font-family: PingFang SC;
font-weight: 400;
color: #869494;
height: 90px; 
overflow: hidden;
margin-top: 0px;
}
.f14 p{padding: 0; margin:0 !important}
.f12{ 
font-size: 14px;
font-family: PingFang SC;
font-weight: bold;
color: #9CA6A6;

} 
.last {
    display: inline-block;
    padding: 2px 4px;
    background: rgba(75, 204, 170, 1);
    border-radius: 2px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    margin-right: 10px;
}
.floatright{float:right}
.ludubi {
    padding-right: 65px;
    margin-right: 15px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(155, 166, 166, 1);
    height: 22px;
    background-image: url(https://objs.auto-learning.com/xcximages/bi3x.png);
    background-position: right top;
    background-repeat: no-repeat;
    background-size: 65px 18px;
    display: inline-block; 
}
</style>

<script>
export default {
    name: "LianZai",
    props: [
        "books"
    ]
}
</script>
